import { ExternalArrow } from "./icons";
import { PageCtx } from "./ctx";
import { rich } from "./rich";

/**
 * "Add Stippl to {assistant} in under a minute": the one-click button to the assistant's directory listing, the
 * same steps by hand and the "then just ask" prompt. Both assistants have a listing, so neither shows a
 * custom-server box any more.
 */
export default function Setup({ ctx }: { ctx: PageCtx }) {
	const { assistant, tr, trA, listingUrl, promptHref, trackCta } = ctx;
	const isClaude = assistant === "claude";

	return (
		<section className="setup" id="connect" aria-labelledby="atp-setup-h">
			<div className="wrap">
				<div className="sec-head">
					<p className="eyebrow">{tr("setup.eyebrow")}</p>
					<h2 className="h2" id="atp-setup-h">
						{tr("setup.h2")}
					</h2>
					<p className="lede">{tr("setup.lede")}</p>
				</div>
				<div className="setup-grid">
					<div className="panel">
						<h3>
							{trA("setup.panelTitle")}
							{isClaude && (
								<>
									{" "}
									<span style={{ font: "500 13px var(--body)", color: "var(--muted)" }}>{trA("setup.panelNote")}</span>
								</>
							)}
						</h3>
						<a
							className="btn btn-green"
							href={listingUrl}
							target="_blank"
							rel="noopener"
							data-where="setup-oneclick"
							style={{ width: "fit-content" }}
							onClick={() => trackCta("setup-oneclick", "add_connector")}
						>
							{trA("setup.oneClick")}
							<ExternalArrow />
						</a>
						<p style={{ fontSize: 14, color: "var(--muted)" }}>{rich(trA("setup.oneClickHelp"))}</p>
						<ol className="steps">
							<li>
								<span>{rich(trA("setup.step1"))}</span>
							</li>
							<li>
								<span>{rich(trA("setup.step2"))}</span>
							</li>
							<li>
								<span>{rich(tr("setup.step3"))}</span>
							</li>
							<li>
								<span>{rich(tr("setup.step4"))}</span>
							</li>
						</ol>
					</div>
					<div className="side">
						<div className="once">
							<b>{tr("setup.onceTitle")}</b>
							<p>{rich(trA("setup.onceText"))}</p>
							<q>{tr("setup.oncePrompt")}</q>
							<a
								className="btn btn-white gpt-link"
								href={promptHref(tr("setup.oncePrompt"))}
								target="_blank"
								rel="noopener"
								data-where="setup"
								style={{ width: "fit-content", padding: "10px 18px", fontSize: 14 }}
								onClick={() => trackCta("setup", "open_assistant")}
							>
								{tr("setup.onceGo")}
								<ExternalArrow />
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
